import { memo, ReactNode, useCallback, useState } from 'react';
import { Field } from 'react-final-form';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import { IKnmFormRef } from '../../MainModule/interfaces/IKnmFormRef';

interface IKnmRiskIndicatorDocumentProps {
  className?: string;
  disableToAdd: boolean;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  name: string;
  title?: ReactNode;
  watchOnly: boolean;
  acceptedFiles?: string;
}

export const KnmRiskIndicatorDocument = memo(
  ({
    className = '',
    disableToAdd,
    formRef,
    name,
    title = 'Файл',
    watchOnly,
    acceptedFiles = '.pdf,.doc,.docx,.xlsx,.xls,.ods,.png,.jpeg',
  }: IKnmRiskIndicatorDocumentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={className}>
        <div className="shared-group-label">
          {title}
          <Button
            className="shared-btn-add"
            text="Добавить"
            variant="link"
            color="primary"
            type="button"
            id="fileAddButton"
            disabled={watchOnly || disableToAdd}
            onClick={openSignModal}
          />
        </div>
        <Field name={name}>
          {({ meta }) => {
            if (meta.touched && typeof meta.error === 'string') {
              return <p className="shared-input-error">{meta.error}</p>;
            }

            return null;
          }}
        </Field>
        <KnmAttachmentsSigning
          isWatchOnly={watchOnly}
          name={name}
          isRequired={false}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          acceptedFiles={acceptedFiles}
          formRef={formRef}
        />
      </div>
    );
  },
);
